import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import cardHolder from "assets/images/Cardholder.svg"

function CommonAccordian(props) {
  return (
    <div>
      {props?.accordianData?.map((ele, idx) => (
        <div key={ele.id}>
          {ele.subele?.length > 0 ? (
            <Accordion className="">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{ele.name}</Typography>
              </AccordionSummary>
              {ele?.subele?.map((subele, idx) => (
                <AccordionDetails key={subele.id}>
                  <Typography
                    className="borderBottom cursor"
                  >
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="female"
                      name="radio-buttons-group"
                    >
                      <FormControlLabel
                        value={subele.name}
                        control={<Radio />}
                        checked
                        label={<div><span>{subele.name}</span></div>}
                      />
                    </RadioGroup>
                  </Typography>
                </AccordionDetails>
              ))}
            </Accordion>
          ) : (
            <Grid className="dashedBottonLine">
              <Typography>
                {ele.name}
              </Typography>
            </Grid>
          )}
        </div>
      ))}
    </div>
  );
}

export default CommonAccordian;
